/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Unit of measure enumeration for volume. Supported values are:
 * - L (Litre)
 * - gal (gallon)
 *
 */
export var VolumeUomEnum;
(function (VolumeUomEnum) {
    VolumeUomEnum["L"] = "L";
    VolumeUomEnum["GAL"] = "gal";
})(VolumeUomEnum || (VolumeUomEnum = {}));
